<template>
  <div class="page-template add-page deliver-add order-add-page">
    <div class="page-title">{{ title }}
    </div>
    <div class="btn-box">
      <el-button @click="beBack" type="primary" plain>返回</el-button>
    </div>
    <table-template ref="tranferringSummery"
                    :tableOptions="listColumns"
    ></table-template>

    <el-dialog
      title="分店商品调拨详情"
      :visible.sync="listShow"
      width="1000px"
      height="2000px"
      :close-on-click-modal="false"
    >
      <list-operation-new ref="storeGoodsDetail" :tableOptions="storeGoodsDetailColumns"></list-operation-new>
      <el-button style="margin-left: 50%" @click="submitAuth" type="primary" plain>保存</el-button>
    </el-dialog>
  </div>
</template>
<script>

  import pageTemplate from '@/components/template/tableTemplate';
  import listOperationNew from "@/components/template/listOperationNew";
  import api from '@/config/api';

  export default {
    components: {
      pageTemplate,
      listOperationNew
    },
    data() {
      return {
        listShow: false,
        detailCopyData: {},
        // 表格信息配置
        listColumns: {
          disabled: false,
          // 是否显示索引
          indexShow: true,
          columns: [
            {
              label: '条码',
              prop: 'goodsBarCode',
              width: '150',
              align: 'center'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '100',
              align: 'center'
            },
            {
              label: '规格',
              prop: 'goodsSpecs',
              width: '60',
              align: 'center'
            },
            {
              label: '单位',
              prop: 'goodsUnitName',
              width: '60',
              align: 'center'
            },
            {
              label: '配送价',
              prop: 'deliveryPrice',
              width: '100',
              align: 'center'
            },
            {
              label: '分店要货汇总',
              prop: 'goodsNumTotal',
              width: '100',
              align: 'center',
              callback: this.goGoodsDetail
            },
            {
              label: '出库方库存汇总',
              prop: 'inventoryNum',
              width: '100',
              align: 'center'
            },
          ],
          url: api.delivery.requireGoodsSummery,
          param: {}
        },
        storeGoodsDetailColumns: {
          // 是否显示索引
          indexShow: true,
          columns: [
            {
              label: '门店',
              prop: 'storeName',
              align: 'center'
            },
            {
              label: '调拨数量',
              prop: 'goodsNum',
              type: 'inputNumber',
              align: 'center',
              max: 99999.99,
              precision: 3,
              change: this.goodsNumChange
            },
            {
              label: '配送价',
              prop: 'deliveryPrice',
              type: 'inputNumber',
              align: 'center',
              max: 99999.99,
              precision: 2,
              change: this.goodsNumChange
            },
            {
              label: '小计金额',
              prop: 'subtotalAmount',
              align: 'center',
            },
          ],
        },
        checkIndex: ''
      }
    },
    created() {
      this.title = document.title + ' - 调拨汇总';
      this.$nextTick(() => {
        this.listColumns.param = this.$route.query;
        this.$refs['tranferringSummery'].operationSuccess();
      })
    },
    methods: {
      // 返回按钮事件
      beBack() {
        if (!this.isCheck) {
          this.$router.go(-1);
        }
      },
      goGoodsDetail(row) {
        this.listShow = true;
        this.$axios.fetchPost(api.delivery.requireGoodsDetail, {mapIds: row.mapIds}).then(data => {
          if (data.code === 200) {
            this.$refs['storeGoodsDetail'].addMoreRow(data.data, 0);
            this.detailCopyData = data.data;
            console.log(this.detailCopyData);
            console.log(data.data);
          } else {
            this.$message.error("获取调拨详情异常");
          }
        });
      },
      submitAuth() {
        let tableList = this.$refs['storeGoodsDetail'].getTabelData();
        if (tableList.length === 0) {
          this.$message.warning("更新数据不能为空")
        }
        let submitData = [];
        if (tableList.length > 0 && this.detailCopyData.length > 0)
          tableList.map(table => {
            this.detailCopyData.map(item => {
              if (table.id === item.id && table.goodsNum.toFixed(3) !== item.goodsNum) {
                submitData.push(table);
              }
            })
          });
        if (submitData.length > 0) {
          this.$axios.fetchPost(api.delivery.batchUpdateNumber, {goodsMapList: submitData}).then(data => {
            if (data.code === 200) {
              this.$message.success("数据更新成功");
              this.$refs['tranferringSummery'].operationSuccess();
            } else {
              this.$message.error("更新数据异常");
            }
          }).finally(() => {
            this.listShow = false;
          });
        }
        this.listShow = false;
        this.$refs['storeGoodsDetail'].clearTableData();
      },
      goodsNumChange(row) {
        row.subtotalAmount = parseFloat(row.deliveryPrice * row.goodsNum).toFixed(2);
      }
    }
  }
</script>
<style scoped>
  >>> .el-dialog__header {
    margin-bottom: 5px;
  }

  .order-add-page .search-goods-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .order-add-page .search-goods-box .select-good {
    margin-left: 16px;
  }

  .search-goods-input {
    width: 300px;
  }

  /deep/ #goodsText {
    height: 32px;
  }

  /deep/ .importDialog {
    width: 640px;
    min-width: 640px;
  }
</style>



// WEBPACK FOOTER //
// src/page/delivery/TransferringSummery.vue